import { executeEvmTransaction } from '../../utils';
export const arbitrumBridgeSwapper = {
    executeEvmTransaction,
};
